import algoliasearch from 'algoliasearch'

import {VariantList} from '@festi/common/api/rest'
import settings from '@festi/common/constants/settings'
import {onDutyFree} from '@festi/common/constants/channels'

const clientId = settings.algoliaApplicationId
const apiKey = settings.algoliaApiKey
const envPrefix = settings.algoliaEnvPrefix
const algoliaEnv = settings.algoliaEnv
const channel = settings.channel
const channelListingPath = settings.channelListingPath

const ruleContext = onDutyFree ? 'dutyfree_store' : 'elko_store'

const searchClient =
  clientId && apiKey ? algoliasearch(clientId, apiKey) : undefined

const searchIndexes = {
  productVariants: `${envPrefix}_products`,
}

export interface WordSuggestion {
  objectId: string
  query: string
}

export interface CategorySuggestions {
  id: string
  name: string
  slug: string
}

export interface AdviceSuggestions {
  id: string
  name: string
  slug: string
}

export default async function quickSearch(props: string[]) {
  const query = props[0]
  const userToken = props[1]

  return await searchClient?.search<
    VariantList | WordSuggestion | CategorySuggestions
  >([
    {
      indexName: `${searchIndexes.productVariants}_popular`,
      query,
      params: {
        hitsPerPage: 6,
        page: 0,
        attributesToRetrieve: [
          'id',
          'slug',
          'name',
          'sku',
          'firstImage.image',
          'inventoryStatus',
          'product.slug',
          'listings',
          'isInStockWeb',
          'isInStockDutyfree',
        ],
        attributesToHighlight: ['name'],
        facets: ['categories'],
        facetFilters: [`${channelListingPath}:true`],
        clickAnalytics: true,
        ruleContexts: [ruleContext],
        userToken,
      },
    },
    {
      indexName: `qs_${algoliaEnv}_products`,
      query,
      params: {
        hitsPerPage: 6,
        page: 0,
        attributesToHighlight: ['query'],
        highlightPreTag: '<b>',
        highlightPostTag: '</b>',
        userToken,
      },
    },
    {
      indexName: `${algoliaEnv}_categories`,
      query,
      params: {
        hitsPerPage: 4,
        page: 0,
        clickAnalytics: true,
        facetFilters: [`channelListings:${channel}`],
      },
    },
  ])
}
